import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EcaSecurityService } from '@drc-eca/eca-components-lib';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

/**
 * Notifies the eca-portal-service when a user successfully logs in with a
 * product code present in the login URL.
 */
@Injectable({
  providedIn: 'root'
})
export class ProductLoginService {
  private http = inject(HttpClient);
  private securityService = inject(EcaSecurityService);

  notifyProductLogin(userId: string, userEmail: string, productCode: string): Observable<any> {
    if (!userId || !productCode) {
      return of(null);
    }

    const url = `${environment.ecaPortalServiceUrl}/product-login?productCode=${productCode}`;
    const body = {
      userId,
      userEmail,
      productCode,
      timestamp: new Date().toISOString()
    };

    return this.securityService.getToken().pipe(
      switchMap(token => {
        const httpOptions = {
          headers: {
            Authorization: `Bearer ${token}`
          }
        };
        return this.http.post<any>(url, body, httpOptions);
      }),
      catchError(err => {
        console.error('Failed to notify eca-portal-service of product login', err);
        return of(null);
      })
    );
  }
}
